import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Textarea } from "@chakra-ui/react";
import { TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MdApproval  as ApprovalIcon} from "react-icons/md";
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { BatchApprovalB, BatchApprovalT } from "./Modal";
import apiCall from '../../../utils/apiCall';
import { DocumentViewer} from "./Modal";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from '@chakra-ui/react';
import { FaRegFileAlt, FaRegFileAlt as FileIcon } from "react-icons/fa";
import {useAtom,atom} from 'jotai'
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";


const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function TranscriptRequest() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [selected_status,set_selected_status] = useState<null | string>(null);
  const {data:all_transcript_request,isLoading} = useQuery<any>(['all-exam-transcript-requests'],{
    queryFn: async ()=> await apiCall().get('/Exam/TranscriptRequests'),
    select(data:any){
      //console.log(data)
      return data.data.Data
    }
  })
  const [search,set_search] = useState('');

  const [filter_data,set_filter_data] = useState<any>(all_transcript_request);


  const showBatchAproval = () =>{
    set_modal({
      header:'Batch Approval',
      content:<BatchApprovalT/>
    })
    set_open(true);
  }
  
  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    //console.log(val,'val')
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).map(eData => JSON.stringify(eData)).join('').toLowerCase().includes(val.toLowerCase()) );
      //console.log(new_data,'n data')
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_transcript_request)
    }
    else set_filter_data(all_transcript_request)
  }

  const itemsPerPage = 20;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  useEffect(()=>{
    if(selected_status){
      let data = all_transcript_request.filter((eData:any) => eData.Status.toLowerCase() === selected_status.toLowerCase());

        set_filter_data(data);
      
    }
    else{
      set_filter_data(all_transcript_request);
    }
  },[selected_status])

  useEffect(()=>{
    set_filter_data(all_transcript_request)
  },[all_transcript_request])

  return (
    <> 
    {isLoading?<Loader />:
    <Box>
      <TopDisplay label="Transcript Request Approval" button_array={[
          <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<ApprovalIcon/>}     variant="outline"
            colorScheme="var(--dark-green-color)"
            onClick={showBatchAproval}
          >Batch Approval</Button>,
          // <UploadButton label="Upload Candidates" />
        ]} />
       <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)" pos="relative">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <Select placeholder="Status" width="130px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_status(e.target.value)}>
              <option>Approved</option>
              <option>Rejected</option>
              <option>Pending</option>
              {/* <option>Verified</option> */}
          </Select>

        </Flex>
        <Flex mt="25px" flexDir="column" gap="8px">
          <Heading m="0" fontSize="1rem">All  Transcript request</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="10px">
          <Table size='sm'>
            <Thead>
              <Tr >
              {/* <Th sx={HeadStyle}>Id</Th> */}
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>Destination</Th>
                <Th sx={HeadStyle}>Address</Th>
                <Th sx={HeadStyle}>Date Created</Th>
                <Th sx={HeadStyle}>Paid</Th>
                <Th sx={HeadStyle}>Status</Th>
                <Th sx={HeadStyle}>Date Approved</Th>
                <Th sx={HeadStyle} w="20px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.Id}>
                {/* <Td sx={DataStyle}>{eCandidate.Id}</Td> */}
                <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                <Td sx={DataStyle}>{eCandidate.DestinationName}</Td>
                <Td  sx={{...DataStyle,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxW:'150px'}}>{eCandidate.DestinationAddress}</Td>
                <Td sx={DataStyle}>
                        {format(new Date(eCandidate.CreateDate), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eCandidate.CreateDate), "hh:mm a")}
                      </Td>
                <Td sx={DataStyle}>{eCandidate.PaymentCompleted? 'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
                <Td sx={DataStyle}>
                        {format(new Date(eCandidate.ActionDate), "dd/MM/yyyy")}
                        <br />
                        {format(new Date(eCandidate.ActionDate), "hh:mm a")}
                      </Td>
                <Td sx={DataStyle} minW="50px" w="20px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Transcript Request'  
      }
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
    </>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const DocumentPreviewer = ({ candidate }: any) => {
  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  const documents = [
    { label: "WES Form", path: candidate?.Path },
    { label: "Application Letter", path: candidate?.ApplicationLetterPath },
    { label: "Evidence For Request", path: candidate?.EvidenceForRequestPath },
    { label: "Induction Certificate", path: candidate?.InductionCertificatePath },
  ].filter((doc) => doc.path);

  if (documents.length === 0) return null;

  return (
    <>
      {documents.map((doc, index) => (
        <Flex key={doc.label} gap="20px" align="center">
          <Text width="200px" fontWeight="bold">
            {doc.label}:
          </Text>

          <Flex
            align="center"
            gap="8px"
            cursor="pointer"
            color="green.700"
            _hover={{ textDecoration: "underline" }}
            onClick={() => setCurrentIndex(index)}
          >
            <FaRegFileAlt />
            <Text fontSize="md">View document</Text>
          </Flex>
        </Flex>
      ))}

      {/* MODAL */}
      <Modal
        isOpen={currentIndex !== null}
        onClose={() => setCurrentIndex(null)}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {currentIndex !== null && documents[currentIndex].label}
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            {currentIndex !== null && (
              <>
                <iframe
                  src={encodeURI(documents[currentIndex].path!)}
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                />

                <Flex justify="space-between" mt={4} align="center">
                  <Button bg="green" color="white"
                    onClick={() =>
                      setCurrentIndex((prev) =>
                        prev !== null && prev > 0 ? prev - 1 : prev
                      )
                    }
                    isDisabled={currentIndex === 0}
                  >
                    Previous
                  </Button>

                  <Text>
                    {currentIndex + 1} of {documents.length}
                  </Text>

                  <Button bg="green" color="white"
                    onClick={() =>
                      setCurrentIndex((prev) =>
                        prev !== null && prev < documents.length - 1
                          ? prev + 1
                          : prev
                      )
                    }
                    isDisabled={currentIndex === documents.length - 1}
                  >
                    Next
                  </Button>
                </Flex>
              </>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom)
  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }
  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Student Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }



  const handleSingleApproval = () =>{
    set_index(null);
    set_modal({
      header:'Transcript Approval Request',
      content:<ViewSingleApproval {...candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          {/* <GridItem sx={sx} p="8px 4px">View Details</GridItem> */}
          <GridItem sx={sx} p="8px 4px" onClick={handleSingleApproval}>Approve/Reject</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}
//   const useDocumentModal = () => {
//   const [, set_open] = useAtom(openAtom);
//   const [, set_modal] = useAtom(modalAtom);

//   const viewDocument = (title: string, path: string) => {
//     set_modal({
//       header: title,
//       content: (
//         <iframe
//           src={path}
//           title={title}
//           style={{ width: '90vw', height: '90vh', border: 'none' }}
//         />
//       )
//     });
//     set_open(true);
//   };

//   return { viewDocument };
// };

const ViewProfile = (props: any) => {
  // const { viewDocument } = useDocumentModal();
  const c = props.candidate;
  return(
  <Flex flexDir="column" minWidth="600px" gap="50px">
    <Flex align="center" gap="20px">
      <Flex gap="20px">
        {/* <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading> */}
        <Text width="150px"  fontWeight="bold" color="var(--light-text)">Student NO:</Text>
        <Text fontWeight="500">  {props.candidate.StudentNo}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="1fr" templateRows="repeat(3,1fr)" gap="30px">
     
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="bold" color="var(--light-text)">Destination:</Text>
        <Text fontWeight="500">{props.candidate.DestinationName || 'Not available'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px"  fontWeight="bold" color="var(--light-text)">Address:</Text>
        <Text fontWeight="500">{props.candidate.DestinationAddress || 'Not available'}</Text>
      </GridItem>
      <GridItem as={Flex} gap="20px">
        <Text width="150px" fontWeight="bold" color="var(--light-text)">Status:</Text>
        <Text fontWeight="500">{props.candidate.Status || 'Pending'}</Text>
      </GridItem>
       <DocumentPreviewer candidate={c} />
    </Grid>
  </Flex>
  )}
  
  const ViewSingleApproval = (props:any) =>{
  const c = props.candidate;
    const [,set_open] = useAtom(openAtom);
    const [,set_n_open] = useAtom(openNAtom);
    const [,set_modal] = useAtom(modalAtom)
    const [,set_notification] = useAtom(notificationAtom);
    const queryClient = useQueryClient();
     const [Reason,set_reason] = useState(props?.Reason || '');
    // const { viewDocument } = useDocumentModal();

    const {isLoading:approveIsLoading,mutate:update_transcript_approve} = useMutation({
      mutationKey:['new-process-transcript-request'],
      mutationFn: async(payload:any)=> {
        
        return await apiCall().post(`/Exam/TreatTranscriptRequests`,payload)
        .catch(function(error:any){
         // console.log(error,'Big error')
          set_open(false);
          set_notification({
            type:'error',
            message:error?.response?.Message || error?.response?.data?.Message || ' Ooops! Error Occured'
          });
          set_n_open(true);
       })
      },
     onSuccess(data:any){
      set_notification({
        type:'success',
        message:data.data.Message || 'Transcript Request Approved Successfully'
      });

      queryClient.invalidateQueries(['all_transcript_request']);

      set_n_open(true);
      set_open(false);
    },
      onError(error:any){
        set_notification({
          type:'error',
          message:error.data.Message || 'Error Occured'
        });
        set_n_open(true);
      },
      onSettled(){
        set_open(false);

      }
    })
    const {isLoading:rejectIsLoading,mutate:update_transcript_request_reject} = useMutation({
      mutationKey:['new-process-transcript-request'],
      mutationFn: async(payload:any)=>{ 
        
        return await apiCall().post(`/Exam/TreatTranscriptRequests`,payload)
        .catch(function(error:any){
          //console.log(error,'Big error')
          set_open(false);
          set_notification({
            type:'error',
            message:error?.response?.message || error?.response?.data?.message || error?.response?.Message || error?.response?.data?.Message || ' Ooops! Error Occured'
          });
          set_n_open(true);
       })
      },
      onSuccess(data:any){
        //console.log(data,'data')
        set_notification({
          type:'success',
          message:data.data.Message || 'Transcript Request Rejected Successfully'
        });
        set_n_open(true);
        queryClient.invalidateQueries(['all-Transcript-request-reject'])
      },
      onError(error:any){
        set_notification({
          type:'error',
          message:error.Message || error.data.Message || 'Error Occured'
        });
        set_n_open(true);
      },
      onSettled(data,error){
        //console.log(data,error,'test both')
        set_open(false);

      }
    })

      return (
    <Flex flexDir="column" minWidth="600px" gap="50px">
      <Flex gap="10px" flexDir="column">
        <Flex gap="20px">
          <Text fontWeight="bold">Student No:</Text>
          <Text fontWeight="600">{props?.StudentNo}</Text>
        </Flex>

        <Flex gap="20px">
          <Text fontWeight="bold">Destination:</Text>
          <Text fontWeight="600">{props?.DestinationName}</Text>
        </Flex>

        <Flex gap="20px">
          <Text fontWeight="bold">Address:</Text>
          <Text fontWeight="600">{props?.DestinationAddress}</Text>
        </Flex>
        <Flex flexDir="column" gap="20px" mt="10px">
         <DocumentPreviewer candidate={c} />
        </Flex>
        <Flex gap="43px">
          <Text fontWeight="bold">Status:</Text>
          <Text fontWeight="600">{props?.Status}</Text>
        </Flex>
      </Flex>
      <Box>
        <Box fontWeight="bold">Comment</Box>
        <Textarea
          placeholder="comment"
          onChange={(e: any) => set_reason(e.target.value)}
          resize="vertical"
          size="sm"
        />
      </Box>

      {/* ACTION BUTTONS */}
      <Flex justify="center" gap="30px">
        <Button
          onClick={() =>
            update_transcript_approve({
              Action: true,
              ApprovalTypeId: 69,
              Comments: Reason,
              Ids: [props.Id],
            })
          }
          bg="var(--dark-green-color)"
          color="white"
          width="130px"
          disabled={approveIsLoading || rejectIsLoading}
        >
          {approveIsLoading ? 'Loading' : 'Approve'}
        </Button>

        <Button
          onClick={() =>
            update_transcript_request_reject({
              Action: false,
              ApprovalTypeId: 69,
              Comments: Reason,
              Ids: [props.Id],
            })
          }
          colorScheme="red"
          width="130px"
          disabled={rejectIsLoading || approveIsLoading}
        >
          {rejectIsLoading ? 'Loading' : 'Reject'}
        </Button>
      </Flex>
    </Flex>
  );
};

 
